import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";
import Calendar from "../chat-plus-calendar/Calendar";
import { NoRouteView } from "../no-route-view";
import usePlannerMetaData from "../web-app-calendar/hooks/usePlannerMetaData";
import { StorageKeyPrefixProvider } from "../web-app-calendar/hooks/useStorageKeyPrefix";
import Context from "./Context";
import SharedProposal from "./SharedProposal";
import { SharedProposalCalendarDateSync } from "./SharedProposalCalendarDateSync";
import { ProposalErrorProvider, useSetProposalError } from "./hooks/ProposalErrorContext";
import { useSharedProposalContext } from "./hooks/SharedProposalProvider";

export const ProposalLayout = () => {
  const { primaryCalendarId } = usePlannerMetaData();
  const setError = useSetProposalError();
  const {
    ownerCalendarId,
    proposal,
    proposalLoading,
    errorMessage,
    setUpdatedProposal,
  } = useSharedProposalContext();

  if (!proposal) {
    return null;
  }

  if (errorMessage) {
    setError({
      error: new Error(errorMessage),
      message: errorMessage,
      proposalId: proposal.proposalId,
    });
    return null;
  }

  if (proposalLoading) {
    return <CircularProgress />;
  }

  const diff = proposal.diffBlocks[0]?.diffs[0];
  const attendees = getValue(diff?.attendees?.attendeePeopleErrorable)?.list ?? [];
  const userCanConfirmProposal = attendees
    .map((attendee) => attendee.primaryCalendar)
    .includes(primaryCalendarId);

  if (!userCanConfirmProposal) {
    setError({
      error: new Error("User does not have access to this proposal"),
      message: "User does not have access to this proposal",
      proposalId: proposal.proposalId,
    });

    return <NoRouteView />;
  }

  return (
    <ProposalErrorProvider>
      <Context>
        <SharedProposalCalendarDateSync />
        <div
          cw-id="proposalLayout"
          className="cw-flex cw-flex-row cw-grow cw-justify-items-end cw-w-full cw-h-full"
        >
          <div className="cw-self-end cw-h-full cw-flex lg:cw-w-[420px] cw-w-full  cw-border-r cw-border-subtle cw-border-solid">
            <SharedProposal
              setUpdatedProposal={setUpdatedProposal}
              sharedProposal={proposal}
              ownerCalendarId={ownerCalendarId}
            />
          </div>
          <div className="cw-grow cw-flex-1 cw-overflow-hidden">
            <div className="lg:cw-flex cw-hidden lg:cw-w-full cw-transition-all cw-h-full">
              <StorageKeyPrefixProvider prefix="proposal">
                <Calendar />
              </StorageKeyPrefixProvider>
            </div>
          </div>
        </div>
      </Context>
    </ProposalErrorProvider>
  );
};
